import { render, staticRenderFns } from "./EnrollmentPlan.vue?vue&type=template&id=480d1db4&scoped=true&"
import script from "./EnrollmentPlan.vue?vue&type=script&lang=js&"
export * from "./EnrollmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentPlan.vue?vue&type=style&index=0&id=480d1db4&scoped=true&lang=less&"
import style1 from "./EnrollmentPlan.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d1db4",
  null
  
)

export default component.exports